import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {IFormItemsControls, IShadowFieldPass} from '../../../../interface/form-structure';
import {IHttpReturnParam, IHttpSetting} from '../../../../interface/dataset-params';
import {HttpFormDataService} from '../../../../services/services';
import {FormEventService} from '../../../../services/formEventService';
import {GlobalObjectService} from '../../../../class/global-obj';
import {FormItemComponentInterface} from '../../../../interface/component';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';

export interface IDatasetResponse {
    total: number;
    results: IHttpReturnParam[];
}

@Component({
    selector: 'noos-dataset-search',
    templateUrl: './dataset-search.component.html',
    styleUrls: ['./dataset-search.component.scss']
})

@NoosFormTypeService.register('datasetsearch')
export class DatasetSearchComponent implements OnInit, AfterViewInit, FormItemComponentInterface {

    prop: IFormItemsControls;
    setting: IHttpSetting;
    isFilter = false;


    itemData: IHttpReturnParam[] = [];
    thisAppearance: any = 'outline';

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    inputValue: any = '';

    shadowFieldValues: IShadowFieldPass[] = [];

    constructor(private httpService: HttpFormDataService, private eventListenerService: FormEventService) {
        this.setting = GlobalObjectService.getVar('setting');
    }

    ngOnInit() {

        if (this.prop.defaultValue !== '' && this.prop.defaultValueTitle !== '') {
            const insertedValue = {title: this.prop.defaultValueTitle, value: this.prop.defaultValue};
            this.itemData.push(insertedValue);
            this.inputValue = insertedValue;
        }
    }

    displayFn(item: IHttpReturnParam) {
        if (item) {
            return item.title;
        }
    }

    ngAfterViewInit(): void {
        if (this.isFilter) {
            this.prop.requared = false;
        }

        this.shadowFieldValues = GlobalObjectService.getVar('shadow_' + this.formId.toString());


    }

    onKeyUp($event: KeyboardEvent) {
        if (this.inputValue.length < 3 || typeof this.inputValue === 'object') {
            this.itemData = [];
            return;
        }

        this.httpService.searchDataset(this.setting, this.prop.options.dataset_id, this.inputValue.toString(),
            this.shadowFieldValues).subscribe(ret => {
                if (ret.complete) {
                    this.itemData = ret.data;
                    this.selectFormValue('');
                }
            }
        );
        if (this.inputValue.toString() === '') {
            this.selectFormValue('');
        }
    }

    selectFormValue(value) {
        this.prop.defaultValue = value;
        this.eventListenerService.updatedDataSelection({
            fromComponentId: this.prop.id,
            fromComponentName: this.prop.name,
            eventName: this.prop.options.form_selector !== undefined && this.prop.options.form_selector ? 'set_form_id' : 'select',
            triggerValue: value,
            formId: this.formId,
            datasetId: this.datasetId
        });
    }

    selectedFn(e: MatAutocompleteSelectedEvent) {
        if (e && e.option) {
            this.selectFormValue(e.option.value.value);
        }
    }
}
